import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { Fragment, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  CancelCivilUnionFormVM,
  CancelCivilUnionVM,
} from 'mutation/view-models/cancel-civil-union';
import CancelCivilUnionForm from './form';

const CancelCivilUnion = (): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CancelCivilUnionFormVM>();

  const onFieldCancelCivilUnionChange = useEventCallback(
    (key: keyof CancelCivilUnionVM, value: CancelCivilUnionVM[keyof CancelCivilUnionVM]) => {
      formContext.setFieldValue('cancelCivilUnion', {
        ...formContext.values.cancelCivilUnion,
        [key]: value,
      });
    }
  );

  const onFieldsCancelCivilUnionChange = useEventCallback((values: CancelCivilUnionVM) => {
    formContext.setFieldValue('cancelCivilUnion', {
      ...(formContext.values.cancelCivilUnion || {}),
      ...values,
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-cancel-union-civil-content"
          id="panel-cancel-union-civil-header"
          expandIcon={<ExpandMore />}
        >
          {formContext.errors.cancelCivilUnion ? (
            <Close color="error" />
          ) : (
            <Check color="success" />
          )}
          <Typography>Annullamento unione civile</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CancelCivilUnionForm
            values={formContext.values.cancelCivilUnion}
            onChange={onFieldCancelCivilUnionChange}
            onChangeValues={onFieldsCancelCivilUnionChange}
            errors={formContext.errors.cancelCivilUnion as FormikErrors<CancelCivilUnionVM>}
            touched={
              formContext.touched.cancelCivilUnion as unknown as FormikTouched<CancelCivilUnionVM>
            }
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

CancelCivilUnion.displayName = 'Accordion Civil Union component';

export default CancelCivilUnion;
